// import { useCorreios } from "hooks";
// import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     searchInput: {
//       width: "50%",
//     },
//     toolbar: {
//       paddingBottom: theme.spacing(2),
//       borderRadius: "4px",
//       background: "var(--backgroundContent)",
//       width: "100%",
//       "& .MuiToolbar-regular": {
//         padding: 0,
//       },
//     },
//     table: {
//       borderRadius: "4px",
//       background: "var(--backgroundContent)",
//       width: "100%",
//     },
//     margin: {
//       margin: theme.spacing(1),
//     },
//     withoutLabel: {
//       marginTop: theme.spacing(3),
//     },
//     textField: {
//       maxWidth: "calc(100% - 12px)",
//     },
//     input: {
//       "& .MuiInputBase-input": {
//         boxShadow: "none",
//         fontSize: "1.2rem",
//         fontWeight: "500",
//         textTransform: "uppercase",
//       },
//     },
//     checkbox: {
//       "&.MuiCheckbox-colorSecondary.Mui-checked": {
//         color: "var(--orange)",
//       },
//       "& .MuiSvgIcon-root": {
//         width: "1.4rem",
//       },
//     },
//     "@media (max-width: 600px)": {
//       searchInput: {
//         width: "100%",
//       },
//     },
//   })
// );
export default function CorreiosTemplate() {
  
  // const { IDMCM } = useCorreios();
  // const classes = useStyles();

  
  return (
    <></>
  );
}
